/**
 * Подтверждение адреса почты по ссылке из письма.
 *
 * Один эндпоинт на четыре назначения токена — регистрация, смена адреса,
 * приглашение, присвоение бесплатного аудита — и при успехе он сразу выставляет
 * куки. Второго шага «теперь войдите» здесь нет и быть не должно: человек уже
 * доказал, что читает эту почту.
 *
 * Экран сам себя не открывает дважды: подтверждение — небезопасный метод,
 * который гасит токен, а `StrictMode` в разработке вызывает эффекты по два
 * раза. Отсюда защёлка.
 */

import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { AuthCard } from './AuthCard';
import { Empty, ErrorNotice, Skeleton } from '../../ui/state';
import { verifyEmail, type Session } from '../../api/auth';

type State = { kind: 'working' } | { kind: 'failed'; error: unknown };

export function Verify({ onDone }: { onDone: (session: Session) => void }) {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  // Пустой адрес — это уже ответ, и он известен до всякого запроса.
  const [state, setState] = useState<State>(() =>
    token ? { kind: 'working' } : { kind: 'failed', error: null },
  );
  const started = useRef(false);

  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;

    verifyEmail(token)
      .then(onDone)
      .catch((error: unknown) => setState({ kind: 'failed', error }));
  }, [token, onDone]);

  if (state.kind === 'working') {
    return (
      <AuthCard title="Подтверждаем почту">
        <Skeleton rows={1} />
      </AuthCard>
    );
  }

  return (
    <AuthCard title="Подтвердить не получилось">
      {state.error ? <ErrorNotice error={state.error} /> : null}
      <Empty
        eyebrow="Ссылка не сработала"
        title="Эта ссылка уже использована или устарела"
        action={
          <Link className="btn btn-primary" to="/auth/login">
            Перейти ко входу
          </Link>
        }
      >
        Ссылки подтверждения одноразовые. Если вы уже подтверждали адрес, просто войдите;
        если нет — попросим прислать письмо заново после входа.
      </Empty>
    </AuthCard>
  );
}
